// extracted by mini-css-extract-plugin
export default {"resetButton":"SE52D3P","badge":"_vJtMp_","gray":"D5F9AZC","green":"PD8mv1s","orange":"Mow8RGR","purple":"rrAOqcd","teal":"sJjjups"};